import {Checkbox} from "components";
import {getName} from "helpers/string";
import CheckboxList from "mapx-components/Inputs/CheckboxList";
import React from "react";
import {TCity, TCountry, TRegion, TState} from "../types";
import StateItem from "./StateItem";

type RegionItemProps = {
	region: TRegion;
	country: TCountry;
	expanded: Record<number, boolean>;
	disabled: boolean;
	isSelected: boolean;
	isPartiallySelected: boolean;
	onToggle: () => void;
	onToggleExpand: () => void;
	onToggleState: (state: TState, region: TRegion, country: TCountry) => void;
	onToggleCity: (city: TCity, state: TState, region: TRegion, country: TCountry) => void;
	isStateSelected: (stateId: number, regionId: number, countryId: number) => boolean;
	isStatePartiallySelected: (state: TState, region: TRegion, country: TCountry) => boolean;
	isCitySelected: (
		cityId: number,
		stateId: number,
		regionId: number,
		countryId: number,
	) => boolean;
	toggleExpandItem: (item: TRegion | TState) => void;
};

const RegionItem: React.FC<RegionItemProps> = ({
	region,
	country,
	expanded,
	disabled,
	isSelected,
	isPartiallySelected,
	onToggle,
	onToggleExpand,
	onToggleState,
	onToggleCity,
	isStateSelected,
	isStatePartiallySelected,
	isCitySelected,
	toggleExpandItem,
}) => {
	const hasChildren = region.states !== undefined && region.states.length > 0;

	return (
		<div key={region.id}>
			<CheckboxList.AccordionChildrenContent
				expanded={expanded[country.id]}
				key={region.id}
				childrenExpanded={expanded[region.id]}
				handleExpandClick={onToggleExpand}
				hasChildren={hasChildren}
				treeIndex={2}
				item={region}
			>
				<Checkbox
					borderColor="#0C5850"
					isChecked={isSelected}
					partiallySelected={isPartiallySelected}
					key={region.id}
					label={getName(region.name)}
					onChange={onToggle}
					value={getName(region.name)}
					disabled={disabled}
				/>
			</CheckboxList.AccordionChildrenContent>

			{/* States */}
			{region.states?.map((state) => (
				<StateItem
					key={state.id}
					state={state}
					region={region}
					country={country}
					expanded={expanded}
					disabled={disabled}
					isSelected={isStateSelected(state.id, region.id, country.id)}
					isPartiallySelected={isStatePartiallySelected(state, region, country)}
					hasChildren={state.cities !== undefined && state.cities.length > 0}
					onToggle={() => onToggleState(state, region, country)}
					onToggleExpand={() => toggleExpandItem(state)}
					isCitySelected={isCitySelected}
					onToggleCity={onToggleCity}
				/>
			))}
		</div>
	);
};

export default RegionItem;
